import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import routes from '../routes';
import { getCookie } from '../utils/persistor';
import { useDispatch } from 'react-redux';
import { fetchWebsitesStart } from '../redux/websites/websites.actions';
import { fetchPackagesStart } from '../redux/payments/payments.actions';
import useTranslation from 'hooks/useTranslation';

const mapState = ({ userData, websitesData, paymentsData }) => ({
  isLoggedIn: userData.profile.isLoggedIn,
  accessLevel: userData.profile.accessLevel,
  websites: websitesData.websites,
  packages: paymentsData.packages,
});
const useAdminAuth = () => {
  const { isLoggedIn, accessLevel, websites, packages } = useSelector(mapState);
  const history = useHistory();
  const isLoggedInCookie = getCookie('isLoggedIn');
  const { getAppLocale } = useTranslation('PACKAGE_UPGRADING');

  const dispatch = useDispatch();

  let restrictedIsLoggedIn = null;

  if (isLoggedInCookie !== 'true' && isLoggedInCookie !== 'false') {
    restrictedIsLoggedIn = 'false';
  } else {
    restrictedIsLoggedIn = isLoggedInCookie;
  }

  useEffect(() => {
    if (restrictedIsLoggedIn !== 'true') {
      history.push(routes.login);
    }
  }, [accessLevel, isLoggedIn]);

  useEffect(() => {
    if (isLoggedInCookie) {
      if (!websites.loading && !websites.data) {
        dispatch(fetchWebsitesStart());
      }
      if (!packages.loading && !packages.data) {
        dispatch(fetchPackagesStart(getAppLocale()));
      }
    }
  }, [isLoggedInCookie]);

  // return isAllowedFromRedux || isAllowedInStorage || isAllowed;
  return restrictedIsLoggedIn === 'true';
};

export default useAdminAuth;
